import React from 'react';
import './FileUploadInfo.css';
import { getMaxPdfSize } from '../setupPdfWorker';

// Helper function to format file size for display
const formatFileSize = (bytes) => {
  if (bytes < 1024) return bytes + ' bytes';
  else if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  else return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

/**
 * FileUploadInfo component displays information about supported file formats
 * and any additional help text for the file upload feature.
 * 
 * @returns {JSX.Element} FileUploadInfo component
 */
const FileUploadInfo = () => {
  // Maximum file sizes
  const MAX_PDF_SIZE = getMaxPdfSize(); 
  const MAX_IMAGE_SIZE = 20 * 1024 * 1024; // 20MB for images
  
  return (
    <div className="file-upload-info">
      <div className="supported-formats">
        <span className="supported-formats-label">Supported formats:</span>
        <span className="format-badge">PNG</span>
        <span className="format-badge">JPG</span>
        <span className="format-badge pdf-badge">PDF</span>
      </div>
      
      <div className="upload-tip">
        <p>
          <span className="tip-icon">💡</span>
          For best results, use high-resolution images with clear floor boundaries.
        </p>
        <p>
          <span className="tip-icon">📄</span>
          For PDF files, only the first page will be extracted as an image.
        </p>
        <p className="size-limits">
          <span className="tip-icon">📊</span>
          Maximum file sizes: {formatFileSize(MAX_IMAGE_SIZE)} for images, {formatFileSize(MAX_PDF_SIZE)} for PDFs.
        </p>
      </div>
    </div>
  );
};

export default FileUploadInfo; 